export const isLocal = window.location.hostname === 'localhost';

export const appEnv = process.env.REACT_APP_ENV;

export const envShowCentralTexas = (process.env.REACT_APP_SHOW_CENTRAL_TX.toLowerCase() === 'true');

export const primaryTheme = process.env.REACT_APP_PRIMARY_THEME;

export const primaryLocation = process.env.REACT_APP_PRIMARY_LOCATION;

export const initialFormState = process.env.REACT_APP_STATE || '';

export const logoNav = `https://mmg-resources.s3.us-west-2.amazonaws.com/logo_pool_pattern_${process.env.REACT_APP_ENV}.svg`

export const getUrlPath = (route) => isLocal ? `http://localhost:3001/${route}` : `/v1/${route}`

const ID_FOR_PEBBLEBREEZE = 7
export const abbreviateMaterialType = (materialType) => (materialType?.id === ID_FOR_PEBBLEBREEZE || materialType?.name?.toLowerCase() === 'pebblebreeze')
    ? 'PZ' //special exception for 'PebbleBreeze' material type
    : materialType?.name?.replace(/[a-z]/g, '') || ''

/////// MAPPING //////
// for fallback
// const extractOsmAddress = (address) => {
//     const customDisplayName = [
//         address.address.house_number || '',
//         address.address.road || '',
//         address.address.city || '',
//         address.address.county || '',
//         address.address.state || '',
//         address.address.postcode || ''].filter(i => i).join(', ')

//     return {
//         name: customDisplayName,
//         id: address.place_id,
//         key: address.place_id,
//         lat: address.lat,
//         lon: address.lon,
//         address: address.address
//     }
// }

// gmaps
export const extractGAddress = (address) => {
    let addr = {}
    address.address_components.forEach(component => {
        component.types.forEach(t => {
            if (t === 'street_number') addr.street_number = component.long_name
            if (t === 'route') addr.road = component.long_name
            if (t === 'locality') addr.city = component.long_name
            if (t === 'administrative_area_level_2') addr.county = component.long_name
            if (t === 'administrative_area_level_1') addr.state = component.long_name
            if (t === 'postal_code') addr.postal_code = component.long_name
        })
    })

    return {
        name: address.formatted_address,
        id: address.place_id,
        key: address.place_id,
        lat: address.geometry.location.lat,
        lon: address.geometry.location.lng,
        address: addr
    }
}

//const OSM_BASE_NOMINATIM_URL = 'https://nominatim.openstreetmap.org/'
const GOOGLE_API = 'https://maps.googleapis.com/maps/api/geocode/'

const G_K = 'AIzaSyBQVw_O7zIqCKIxCouop5eWFkztvCSwioY'


export const buildGeocodeUrl = (address_line_1, city, state, county, zip_code) => {
    let url_parts = [GOOGLE_API, 'json?address=']

    if (address_line_1) url_parts.push(`${address_line_1} `)
    if (city) url_parts.push(`${city} `)
    if (state) url_parts.push(`${state} `)
    if (county) url_parts.push(`${county} `)
    if (zip_code) url_parts.push(`${zip_code} `)
    url_parts.push(`&key=${G_K}`)

    return url_parts.join('')
}

export const filterCrewNamesBySubdivision = (crews, subdivision) => {
    return crews
        .filter(c => c.subdivision.toLowerCase().includes(subdivision.toLowerCase()))
        .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
}
// const buildOsmUrl = (address_line_1, city, state, county, zip_code) => {
//     let url_parts = [OSM_BASE_NOMINATIM_URL, 'search?']

//     if (address_line_1) url_parts.push(`&street=${address_line_1}`)
//     if (city) url_parts.push(`&city=${city}`)
//     if (state) url_parts.push(`&state=${state}`)
//     if (county) url_parts.push(`&county=${county}`)
//     if (zip_code) url_parts.push(`&postalcode=${zip_code}`)
//     url_parts.push(`&country=United States of America`)
//     url_parts.push(`&format=json&addressdetails=1`)

//     return url_parts.join('')
// }

/////// MAPPING END /////////


export const getPresitePath = (jobDetail) => {
    if (!jobDetail.job_category) {
        return 'Presite/'
    }

    let job_types = jobDetail.job_types &&
        jobDetail.job_types.map(j => j.name).join(', ')

    if (!jobDetail.job_category) {
        return ''
    }
    let job_category = `(${jobDetail.job_category.name})`

    const isPebble = jobDetail.job_category.id === 2
    const isGunite = jobDetail.job_category.id === 1

    let date = (isGunite && jobDetail.gunite_details && jobDetail.gunite_details.finished_date)
        || (isPebble && jobDetail.pebble_details && jobDetail.pebble_details.app_date)
        || ''

    let jobDetailName = `${job_types} ${job_category} ${date}`.trim()

    return `Presite/${jobDetailName}/`
}

export const renderYesNo = (boolProp) => boolProp ? 'YES' : 'NO'

//#region Job Loading Optimization

/**
 * Used to recursively compare two objects and receive feedback on any differences found.
 * @param {Object} oldObject - The first object to compare.
 * @param {Object} newObject - The second object to compare.
 * @returns {Object} - An object containing the differences found in the following format:
 * {
 *    path: {Array} - The path to the property that was different.
 *    key: {String} - The name of the property that was different.
 *    valueOldObject: {String} - The value of the property in the first object.
 *    valueNewObject: {String} - The value of the property in the second object.
 * }
 * Necessary for the comparison of nested objects from the Job Loading Optimization and
 * sub-job merging process, since the previous solution was not as thorough with the Lodash library.
 */
export function traverseObjectAndCompare(oldObject, newObject) {
    const keyTracker = []
    const path = []
    return function _traverseObjectAndCompare(oldObject, newObject, keyTracker, path, keyName) {
        const oldObjectType = typeof oldObject
        const newObjectType = typeof newObject

        if (oldObjectType !== newObjectType) {
            return keyTracker.push({
                path: path.slice(0, -1),
                key: keyName,
                oldValue: oldObject,
                newValue: newObject
            })
        }

        const isOldObjectAnObject = !!(oldObject && oldObjectType === "object" && !Array.isArray(oldObject))
        const isOldObjectAnArray = !!(oldObject && oldObjectType === "object" && Array.isArray(oldObject))

        const isNewObjectAnObject = !!(newObject && newObjectType === "object" && !Array.isArray(newObject))
        const isNewObjectAnArray = !!(newObject && newObjectType === "object" && Array.isArray(newObject))

        if (isOldObjectAnObject && isNewObjectAnObject) {
            for (let key in oldObject) {
                if (oldObject.hasOwnProperty(key) && newObject.hasOwnProperty(key)) {
                    path.push(key)
                    _traverseObjectAndCompare(oldObject[key], newObject[key], keyTracker, path, key)
                    path.pop()
                } else {
                    keyTracker.push({
                        path: path.slice(0, -1),
                        key: key,
                        oldValue: oldObject[key],
                        newValue: newObject[key],
                    })
                }
            }
        } else if (isOldObjectAnArray && isNewObjectAnArray) {
            if (oldObject.length !== newObject.length) {
                keyTracker.push({
                    path: path.slice(0, -1),
                    key: keyName,
                    oldValue: oldObject,
                    newValue: newObject
                })
            }
            for (let i = 0; i < oldObject.length; i++) {
                path.push(i)
                _traverseObjectAndCompare(oldObject[i], newObject[i], keyTracker, path, `${keyName}[${i}]`)
                path.pop()
            }
        } else if (oldObject !== newObject) {
            keyTracker.push({
                path: path.slice(0, -1),
                key: keyName,
                oldValue: oldObject,
                newValue: newObject
            })
        }

        return keyTracker
    }(oldObject, newObject, keyTracker, path)
}

export function selectiveObjectOverwrite(obj, differences, preferOldValues = true) {
    for (const difference of differences) {
        const { path, key, oldValue, newValue } = difference
        const value = preferOldValues ? oldValue : newValue

        // creates a pointer to the object
        let schema = obj
        for (const _key of path) {
            // navigate to the object we want to change
            schema = schema[_key]
        }
        // overwrite the object at the key with the new value
        schema[key] = value
    }
    return obj
}

//#endregion
export const putInS3 = (presignedUrl, d) => new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    xhr.open('PUT', presignedUrl, true)
    xhr.setRequestHeader('Content-Type', d.type)
    xhr.onload = async () => {
        if (xhr.status >= 200 && xhr.status <= 300) {
            resolve(d)
        }
        else {
            reject({
                statusText: xhr.statusText
            })
        }
    }
    xhr.onerror = () => {
        reject({
            err: `error in xhr request ${xhr.statusText}`
        })
    }
    xhr.send(d)
})